import React, { createContext, useContext, useEffect, useMemo, useState } from "react"
import { DISPLAY_CURRENCY_OPTIONS } from "../constants/currencies"

const STORAGE_KEY = "exchangeos.display_currency"
const DEFAULT_CURRENCY = "USD"

const ALLOWED_DISPLAY_CURRENCIES = new Set(
    DISPLAY_CURRENCY_OPTIONS.map((item) => item.value)
)

const DisplayCurrencyContext = createContext({
    displayCurrency: DEFAULT_CURRENCY,
    setDisplayCurrency: () => {},
})

export const DisplayCurrencyProvider = ({ children }) => {
    const [displayCurrency, setDisplayCurrencyState] = useState(DEFAULT_CURRENCY)

    useEffect(() => {
        try {
            const saved = window.localStorage.getItem(STORAGE_KEY)
            const normalizedSaved = String(saved || "").toUpperCase()

            if (ALLOWED_DISPLAY_CURRENCIES.has(normalizedSaved)) {
                setDisplayCurrencyState(normalizedSaved)
            } else {
                setDisplayCurrencyState(DEFAULT_CURRENCY)
            }
        } catch (error) {
            console.error("Failed to read display currency from storage:", error)
        }
    }, [])

    const setDisplayCurrency = (value) => {
        const normalizedValue = String(value || DEFAULT_CURRENCY).toUpperCase()
        const safeValue = ALLOWED_DISPLAY_CURRENCIES.has(normalizedValue)
            ? normalizedValue
            : DEFAULT_CURRENCY

        setDisplayCurrencyState(safeValue)

        try {
            window.localStorage.setItem(STORAGE_KEY, safeValue)
        } catch (error) {
            console.error("Failed to save display currency to storage:", error)
        }
    }

    const contextValue = useMemo(
        () => ({
            displayCurrency,
            setDisplayCurrency,
        }),
        [displayCurrency]
    )

    return (
        <DisplayCurrencyContext.Provider value={contextValue}>
            {children}
        </DisplayCurrencyContext.Provider>
    )
}

export const useDisplayCurrency = () => useContext(DisplayCurrencyContext)